<template>
    <treemap-chart :data="tests" :blurredChart="!$store.getters['session/userHasCompanies'] && userIsPatient" :blurredChartMsg="$t('errorMessages.only-subscribed-users')"></treemap-chart>
</template>

<script>
import { GREEN_COLOUR, RED_COLOUR, YELLOW_COLOUR, ORANGE_MID_COLOUR, GREEN_LIGHT_COLOUR, BACKGROUND_COLOUR } from '@/constants/colours.js'
import { testRoute } from '@/helpers/tests.helpers'
import PatientsRepository from '@/repositories/PatientsRepository'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import TreemapChart from '@/components/charts/TreemapChart.vue'
import { POSITIVE_IMPACT_TESTS, TEST_ANXIETY_BECK, TEST_CARDIOVASCULAR_RISK, TEST_FINDRISK, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_MEDITERRANEAN_DIET, TEST_NICOTINE_DEPENDENCY, TEST_PHYSICAL_ACTIVITY, TEST_RYFF_SCALE, TEST_SLEEP_QUALITY, TEST_GENERAL_HEALTH, TEST_SOCIAL_SKILLS, TEST_STRESS } from '@/constants/patientServices'

const HIGHEST_RESULT = 80
const HIGH_RESULT = 60
const MID_RESULT = 40
const LOW_RESULT = 20

const TEST_NOT_COMPLETED = -1

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        TreemapChart
    },
    data () {
        return {
            tests: [],
            visibleTests: [],
            dataSignificance: {
                [TEST_GENERAL_HEALTH]: 9,
                [TEST_RYFF_SCALE]: 7,
                [TEST_CARDIOVASCULAR_RISK]: 7,
                [TEST_ANXIETY_BECK]: 5,
                [TEST_STRESS]: 5,
                [TEST_MEDITERRANEAN_DIET]: 5,
                [TEST_FINDRISK]: 5,
                [TEST_SLEEP_QUALITY]: 5,
                [TEST_SOCIAL_SKILLS]: 5,
                [TEST_INTERPERSONAL_RELATIONSHIPS]: 5,
                [TEST_PHYSICAL_ACTIVITY]: 3,
                [TEST_NICOTINE_DEPENDENCY]: 3
            }
        }
    },
    created () {
        const id = this.userIsPatient ? this.$store.state.session.user.id : null
        const patientId = this.userIsPatient ? null : this.$route.query.patientId
        PatientsRepository.GetLastCompletedFromEachTest(id, patientId).then((response) => {
            response.data.forEach(({ testName, monthResult }) => {
                var completed = monthResult !== TEST_NOT_COMPLETED
                var resultInfo = null
                if (completed) resultInfo = this.testResultsInfo(testName, monthResult)
                const t = {
                    name: this.$t(`tests.testNamesForResultsDiagram.${testName}`),
                    tooltipText: !completed ? this.$t('tests.notCompleted').toUpperCase() : resultInfo && resultInfo.tag ? resultInfo.tag.toUpperCase() : `${monthResult}%`,
                    color: resultInfo && resultInfo.color ? resultInfo.color : this.pieSliceColor(testName, monthResult),
                    completed: completed,
                    route: this.setTestRoute(testName, completed),
                    value: this.dataSignificance[testName]
                }
                t.formatter = `<div style="overflow: hidden; height:100%; width:100%; text-align: center"><img height="25" width="25" class="in-chart-icon" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/test-${testName.replace('Test ', '').toLocaleLowerCase().replace(' ', '-')}.svg" />`
                this.tests.push(t)
            })
        })
    },
    methods: {
        pieSliceColor (test, percent) {
            if (percent === TEST_NOT_COMPLETED) return BACKGROUND_COLOUR
            if (POSITIVE_IMPACT_TESTS.includes(test)) {
                return percent >= HIGHEST_RESULT ? GREEN_COLOUR : percent >= HIGH_RESULT ? GREEN_LIGHT_COLOUR : percent >= MID_RESULT ? YELLOW_COLOUR : percent >= LOW_RESULT ? ORANGE_MID_COLOUR : RED_COLOUR
            } else {
                return percent >= HIGHEST_RESULT ? RED_COLOUR : percent >= HIGH_RESULT ? ORANGE_MID_COLOUR : percent >= MID_RESULT ? YELLOW_COLOUR : percent >= LOW_RESULT ? GREEN_LIGHT_COLOUR : GREEN_COLOUR
            }
        },
        setTestRoute (testName, completed) {
            if (this.userIsPatient || (!this.userIsPatient && completed)) {
                let pathId = testName.replace('Test ', '').toLocaleLowerCase().replace(' ', '-')
                let route = `/patient/${testRoute(pathId)}`
                let routeIfProf = !this.userIsPatient ? `/${this.$route.query.patientId}` : ''
                return route + routeIfProf
            }
        }
    },
    computed: {
        userAgeNotValid () {
            const age = this.$store.state.session.user.age
            return age <= 18 || age >= 67
        },
        companyServices () {
            return this.$store.state.session.user && this.$store.state.session.user.activeCompanyServices ? this.$store.state.session.user.activeCompanyServices : []
        },
        userIsPatient () {
            return this.$store.getters['session/userIsPatient']
        }
    }
}
</script>
<style>
    .highcharts-tooltip {
        z-index: 9999 !important;
    }
    .in-chart-icon {
      filter: invert(38%) brightness(70%) saturate(100%);
      object-fit: contain;
    }
</style>


// WEBPACK FOOTER //
// src/components/charts/SelfEvaluationTestDiagram.vue